import React, { useState } from "react"
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap"
import ModalFooter from "reactstrap/lib/ModalFooter"
import { postForfeit } from "../../api"
import { forfeitMatch } from "../../api/socket/functions"
import styles from "./ForfeitDialog.module.scss"

function ForfeitDialog({
	homeTeamName = JSON.parse(localStorage.getItem("homeTeam") ?? "{}").name,
	awayTeamName = JSON.parse(localStorage.getItem("awayTeam") ?? "{}").name,
	sport = localStorage.getItem("sport"),
	gameId = JSON.parse(localStorage.getItem("gameDetails") ?? "{}").gameId,
	onDone,
	isFlat = false,
	updateSocket = false,
}) {
	if (
		JSON.parse(localStorage.getItem("spectate" ?? false)) ||
		localStorage.getItem("penaltiesOrEnd") === "done"
	) {
		return <></>
	}

	const [isModalOpen, setIsModalOpen] = useState(false)
	const [isWarningOpen, setIsWarningOpen] = useState(false)
	const [isHomeTeam, setIsHomeTeam] = useState(false)
	const [isAwayTeam, setIsAwayTeam] = useState(false)

	const onForfeit = () => {
		setIsWarningOpen(false)
		setIsModalOpen(false)
		if (updateSocket) forfeitMatch({ isHome: isHomeTeam, isAway: isAwayTeam })
		postForfeit({ isHome: isHomeTeam, isAway: isAwayTeam, sport, gameId })
		onDone()
	}

	return (
		<>
			<Button.Ripple
				outline={!isFlat}
				color={isFlat ? "flat-secondary" : "secondary"}
				onClick={() => setIsModalOpen(true)}
			>
				Forfeit
			</Button.Ripple>
			<Modal
				isOpen={isModalOpen}
				toggle={() => setIsModalOpen(false)}
				className="modal-dialog-centered modal-sm"
			>
				<ModalHeader toggle={() => setIsModalOpen(false)}>
					Forfeit
				</ModalHeader>
				<ModalBody>
					<p>Biraj koje ekipe se predaju</p>
					<div className={styles.grid}>
						<Button.Ripple
							color="primary"
							outline={!isHomeTeam}
							onClick={() => setIsHomeTeam(!isHomeTeam)}
						>
							{homeTeamName}
						</Button.Ripple>
						<Button.Ripple
							color="primary"
							outline={!isAwayTeam}
							onClick={() => setIsAwayTeam(!isAwayTeam)}
						>
							{awayTeamName}
						</Button.Ripple>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button.Ripple
						color="primary"
						disabled={!isHomeTeam && !isAwayTeam}
						onClick={() => setIsWarningOpen(true)}
					>
						Spremi
					</Button.Ripple>
					<Button.Ripple outline onClick={() => setIsModalOpen(false)}>
						Odustani
					</Button.Ripple>
				</ModalFooter>
			</Modal>
			<Modal isOpen={isWarningOpen} toggle={() => setIsWarningOpen(false)}>
				<ModalHeader toggle={() => setIsWarningOpen(false)}>
					Jesi li siguran
				</ModalHeader>
				<ModalBody>
					<p style={{ color: "red" }}>Ova akcija se nemože poništit</p>
					<p>
						Namješteno je da se{" "}
						{isHomeTeam && isAwayTeam ? (
							<>
								<b>obe ekipe</b> predaju
							</>
						) : (
							<>
								<b>
									{isHomeTeam
										? `${homeTeamName}`
										: `${awayTeamName}`}
								</b>{" "}
								predaje
							</>
						)}
					</p>
				</ModalBody>
				<ModalFooter>
					<Button.Ripple color="primary" onClick={onForfeit}>
						Nastavi
					</Button.Ripple>
					<Button.Ripple outline onClick={() => setIsWarningOpen(false)}>
						Odustani
					</Button.Ripple>
				</ModalFooter>
			</Modal>
		</>
	)
}

export default ForfeitDialog
